exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.cube-image-preview-footer{\n  display: none;\n}\n", "", {"version":3,"sources":["D:/projects/cn/course_web/projects/self_work/src/App.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf","file":"App.vue","sourcesContent":["\n.cube-image-preview-footer{\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d65fbadc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = lGbl
// module chunks = 79